import styled from 'styled-components'

export const RehearsalControlsContainer = styled.div`
  margin: 20px 0;
  padding: 15px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.secondaryBackground};

  @media (max-width: 600px) {
    margin: 15px 0;
    padding: 12px;
  }
`

export const RehearsalStatus = styled.div`
  margin-bottom: 15px;
  padding: 10px;
  background-color: ${({ theme }) => theme.background};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.borderColorDark};
`

export const StatusLabel = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.primary};
`

export const StatusInfo = styled.div`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.bodyText};
  margin-bottom: 3px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    
    button {
      width: 100%;
    }
  }
`
